import { useMemo } from "react";
import { useWalletContext } from "../store";
export const useWalletOptions = () => {
    const { state: { options }, } = useWalletContext();
    const memoizedMetadataResolver = useMemo(() => options.metadataResolver, [options.metadataResolver]);
    return {
        options: {
            ...options,
            metadataResolver: memoizedMetadataResolver,
        },
    };
};
//# sourceMappingURL=useWalletOptions.js.map